import { Flex, Stack, Text } from '@chakra-ui/react';

import CircleEditButton from '@/client/components/shared/buttons/CircleEditButton';
import ExpertGoogleDriveIntegrationForm from './google-drive-upload/ExpertGoogleDriveIntegrationForm';
import ExpertLocalUploadIntegrationForm from './local-upload/ExpertLocalUploadIntegrationForm';
import ExpertOneDriveIntegrationForm from './ExpertOneDriveIntegrationForm';
import { useExpertsStore } from '../../expertsStore';
import { useTranslation } from 'react-i18next';

export default function ExpertIntegrationsForm() {
  const { t } = useTranslation();
  const { isEditingExpert: isEditing, setIsEditingExpert } = useExpertsStore();

  return (
    <Stack spacing={8}>
      <Flex justifyContent="space-between" alignItems="center">
        <Text variant="createHeading">{t('admin.aiAgent.experts.form.integrations.title')}</Text>

        {!isEditing && (
          <CircleEditButton colorScheme="neutral" onClick={() => setIsEditingExpert(true)} />
        )}
      </Flex>

      <Stack spacing={6}>
        <ExpertLocalUploadIntegrationForm />

        <ExpertGoogleDriveIntegrationForm />

        <ExpertOneDriveIntegrationForm />
      </Stack>
    </Stack>
  );
}
